import {loadLookupRecord} from '../../../../utils/effectivePermissions';
import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import { AutoComplete } from 'primereact/autocomplete';

const PurchaseorderFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    deadline: new Date(),
  });
  const [newFormData, setNewFormData] = useState({});
  const [locations, setLocations] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [statusDictionary, setStatusDictionary] = useState([]);
  const [contactDisplay, setContactDisplay] = useState("");
  const [contactSuggestions, setContactSuggestions] = useState([]);
  const [projects, setProjects] = useState([]);
  const [projectDisplay, setProjectDisplay] = useState("");
  const [projectSuggestions, setProjectSuggestions] = useState([]);
  const [projectSelected, setProjectSelected] = useState(false);
  const [warehouses, setWarehouses] = useState([]);

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };

  const searchContact = (event) => {
    const query = (event.query || "").toLowerCase().trim();

    if (!query) {
      setContactSuggestions([]);
      return;
    }

    const filtered = employees
      .filter(u => {
        const name = (u.name || "").toLowerCase();
        return name.includes(query);
      })
      .map(u => ({
        ...u,
        name: u.name
      }));

    setContactSuggestions(filtered);
  };

  // const getNextStatuses = (current) => {
  //   const map = {
  //     NEW: ['IN_PROGRESS', 'DELETED'],
  //     IN_PROGRESS: ['COMPOSED', 'DELETED'],
  //     COMPOSED: ['ORDERED'],
  //     ORDERED: ['CLOSED'],
  //     RECEIVING: ['CLOSED'],
  //   };
  //   const keys = map[(current || '').toUpperCase()] || [];
  //   return keys
  //     .map(k => statusDictionary.find(s => String(s.key).toUpperCase() === k))
  //     .filter(Boolean);
  // };

  const onSubmit = (data, form) => {
    setLoading(true)
    if ((window.App.urlVars().purchaseorderId) || (entity === 'purchase-order' && id)) {
      apiCall('patch', '/api/v2/purchase-order/' + (window.App.urlVars().purchaseorderId ?? id), newFormData)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderPurchaseorderList: Math.random()})
          if (props.goback === true) {
            history.push(window.App.urlVars().return);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/purchase-order', data)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderPurchaseorderList: Math.random()})
          if (props.goback === true) {
            history.push('/procurement/purchase-order/read/' + response.data.data.id);
          } else {
            history.push('/procurement/purchase-order/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }
  // const toolbarOptions = {
  //   container: [
  //     [{'header': [1, 2, 3, 4, 5, 6, false]}],
  //     ['bold', 'italic', 'underline', 'strike'],
  //     ['image', 'formula'],
  //     [{'align': []}],

  //     [{'list': 'ordered'}, {'list': 'bullet'}, {'list': 'check'}],
  //     [{'script': 'sub'}, {'script': 'super'}],
  //     [{'indent': '-1'}, {'indent': '+1'}],
  //     [{'color': []}, {'background': []}],
  //     ['clean']
  //   ]
  // }

  const searchProject = (event) => {
    const query = (event.query || "").toLowerCase().trim();
    if (!query) {
      setProjectSuggestions([]);
      return;
    }
    const filtered = projects
      .filter(p => ((p.name || "").toLowerCase()).includes(query))
      .map(p => ({ ...p, name: p.name }));
    setProjectSuggestions(filtered);
  };

  const loadWarehouses = async (projectOrId) => {
    const projectId = typeof projectOrId === 'object' ? projectOrId?.id : projectOrId;
    if (!projectId) { setWarehouses([]); return; }
    try {
      const response = await loadLookupRecord(apiCall, 'project', projectId, 'ROLE_PROJECT_READ');
      const warehouse = response?.data?.data?.warehouse;
      setWarehouses(warehouse ? [warehouse] : []);
    } catch (error) {
      setWarehouses([]);
      window.App.toastShow('error', t('error'), error.toString(), '', error.response);
    }
  };

  const purchaseOrderId = window.App.urlVars().purchaseorderId ?? id;

  useEffect(() => {
    apiCall('GET', '/api/v2/project?limit=9999')
      .then(res => {
        const list = res.data?.data?.items || [];
        setProjects(list);
        if (formData?.project && typeof formData.project === "object") {
          setProjectDisplay(formData.project.name || "");
        } else if (formData?.project) {
          const hit = list.find(p => String(p.id) === String(formData.project));
          if (hit) setProjectDisplay(hit.name || "");
        }
      })
      .catch(err => window.App.toastShow('error', t('error'), err.toString(), '', err.response));

  }, []);

  useEffect(() => {
    const vars = window.App.urlVars();
    if (vars.projectName) {
      const decodedProjName = decodeURIComponent(vars.projectName);
      setProjectDisplay(decodedProjName);
      setFormData(prev => ({ ...prev, project: vars.projectId || prev.project }));
      setNewFormData(prev => ({ ...prev, project: vars.projectId || prev.project }));
    }
  }, [window.App.urlVars().projectName, projects.length]);

  useEffect(() => {
    const projectId = formData?.project?.id || formData?.project;
    if (projectId && projects.length > 0) {
      const fullProject = projects.find(p => String(p.id) === String(projectId));
      if (fullProject) {
        setProjectDisplay(fullProject.name || "");
        loadWarehouses(fullProject);
      }
    }
  }, [formData.project, projects]);

  useEffect(() => {
    apiCall('GET', '/api/v2/location')
      .then(response => {
        setLocations(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    // apiCall('get', '/user')
    //   .then(response => {
    //     setUsers(response.data.items)
    //   })
    //   .catch(error => {
    //     window.App.toastShow('error', t('error'), error.toString(), '', error.response);
    //   })

    apiCall('get', '/api/v2/employee?limit=9999')
      .then(response => {
        const list = response.data?.data?.items || [];
        setEmployees(list);
        // setUsers(response.data.items)
        if (formData?.contact && typeof formData.contact === 'object') {
          setContactDisplay(formData.contact.name || "");
        } else if (formData?.contact) {
          const hit = list.find(u => String(u.id) === String(formData.contact));
          if (hit) {
            setContactDisplay(hit.name || "");
          }
        }
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })

    if (((!window.App.urlVars().create && window.App.urlVars().purchaseorderId) || (entity === 'purchase-order' && id)) && (purchaseOrderId !== 'undefined')) {
      setLoading(true);
      apiCall('get', '/api/v2/purchase-order/' + (window.App.urlVars().purchaseorderId ?? id))
        .then(response => {
          setFormData(response.data.data)
          const data = response.data.data;
          if (data?.contact && typeof data.contact === 'object') {
            setContactDisplay(data.contact.name || "");
          } else if (data?.contact) {
            const hit = employees.find(u => String(u.id) === String(data.contact));
            if (hit) {
              setContactDisplay(hit.name || "");
            }
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [window.App.state.rerenderPurchaseorderForm])

  useEffect(() => {
    if(formData.status && formData.status === 'NEW') {
      setStatuses([
        {
          key: "IN_PROGRESS",
          value: "IN_PROGRESS"
        },
        {
          key: "DELETED",
          value: "DELETED"
        },
      ])
    }
    if(formData.status && formData.status === 'IN_PROGRESS') {
      setStatuses([
        {
          key: "COMPOSED",
          value: "COMPOSED"
        },
        {
          key: "DELETED",
          value: "DELETED"
        },
      ])
    }
    if(formData.status && formData.status === 'COMPOSED') {
      setStatuses([
        {
          key: "ORDERED",
          value: "ORDERED"
        },
      ])
    }
    if(formData.status && formData.status === 'ORDERED') {
      setStatuses([
        {
          key: "CLOSED",
          value: "CLOSED"
        },
      ])
    }
  }, [formData.status])

  useEffect(() => {
    apiCall('GET', '/api/v2/dictionary/purchase-order-status')
      .then(res => {
        setStatusDictionary(res.data?.data || []);
      })
      .catch(err => {
        window.App.toastShow('error', t('error'), err.toString(), '', err.response);
      });

    // apiCall('GET', '/my-profile')
    //   .then(response => {
    //     setProfile(response.data);
    //     const employeeId = response?.data?.employee?.id;
    //     const employeeName = response?.data?.employeeName
    //     if (employeeId) {
    //       localStorage.setItem('employeeId', employeeId);
    //     }
    //     if (employeeName) {
    //       localStorage.setItem('employeeName', employeeName);
    //     }
    //     if (!purchaseOrderId || purchaseOrderId === 'undefined') {
    //       setFormData(prev => ({
    //         ...prev,
    //         contact: employeeId || prev.contact
    //       }));
    //       setNewFormData(prev => ({
    //         ...prev,
    //         contact: employeeId || prev.contact
    //       }));
    //       if (employeeName) {
    //         setContactDisplay(employeeName);
    //       }
    //     }
    //   })
    //   .catch(error => {
    //     window.App.toastShow('error', t('error'), error.toString(), '', error.response);
    //   });
  }, [purchaseOrderId]);


  useEffect(() => {
    const employeeId = localStorage.getItem('employeeId');
    if (!purchaseOrderId || purchaseOrderId === 'undefined') {
      if (employeeId && employees.length > 0 && !formData.contact) {
        const emp = employees.find(e => String(e.id) === String(employeeId));
        if (emp) {
          setContactDisplay(emp.name || '');
          setFormData(prev => ({
            ...prev,
            contact: emp.id
          }));
          setNewFormData(prev => ({
            ...prev,
            contact: emp.id
          }));
        }
      }
    }
  }, [employees, purchaseOrderId, formData.contact]);

  useEffect(() => {
    const urlVars = window.App.urlVars();
    if (urlVars.employeeName) {
      const decodedName = decodeURIComponent(urlVars.employeeName);

      setContactDisplay(decodedName);

      setFormData(prev => ({
        ...prev,
        contact: urlVars.employeeId || prev.contact
      }));

      setNewFormData(prev => ({
        ...prev,
        contact: urlVars.employeeId || prev.contact
      }));
    }
  }, [window.App.urlVars().employeeName]);

  return (
    <div className={"purchaseorder-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            {/*<div className={"p-col-12 p-lg-3"}>*/}
            {/*  <Field name="reference_type" render={({input, meta}) => (*/}
            {/*    <div className="p-field p-fluid">*/}
            {/*      <label htmlFor="reference_type"*/}
            {/*             className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldReferenceType')}</label>*/}
            {/*      <span className="p-d-block">*/}
            {/*          <Dropdown {...input}*/}
            {/*                    onChange={(e) => {*/}
            {/*                      setFormData({*/}
            {/*                        ...formData,*/}
            {/*                        reference_type: e.target.value*/}
            {/*                      })*/}
            {/*                      setNewFormData({*/}
            {/*                        ...newFormData,*/}
            {/*                        reference_type: e.target.value*/}
            {/*                      })*/}

            {/*                    }}*/}
            {/*                    value={formData.reference_type?.id || formData.reference_type}*/}
            {/*                    options={[*/}
            {/*                      {*/}
            {/*                        label: "Projekt",*/}
            {/*                        key: "PROJECT",*/}
            {/*                      },*/}
            {/*                      {*/}
            {/*                        label: "Készlet",*/}
            {/*                        key: "INVENTORY",*/}
            {/*                      }*/}
            {/*                    ]}*/}
            {/*                    optionLabel="label"*/}
            {/*                    optionValue="key"*/}
            {/*                    id={"reference_type"}*/}
            {/*                    emptyMessage={t('noTargetYet')}*/}
            {/*                    className={classNames({'p-error': isFormFieldValid(meta)})}*/}
            {/*          />*/}
            {/*        </span>*/}
            {/*      {getFormErrorMessage(meta)}*/}
            {/*    </div>*/}
            {/*  )}/>*/}
            {/*</div>*/}
            <div className={"p-col-12 p-lg-6"}>
              {/* <Field name="location" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="location"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldDeliveryAddress')}</label>
                  <span className={"p-d-block"}>
                              <Dropdown {...input}
                                        onChange={(e) => {
                                          setFormData({
                                            ...formData,
                                            location: e.target.value
                                          })
                                          setNewFormData({
                                            ...newFormData,
                                            location: e.target.value
                                          })
                                        }}
                                        value={formData?.location?.id || formData.location}
                                        disabled={window.App.urlVars().locationId || id}
                                        options={locations}
                                        filter
                                        optionLabel="name"
                                        optionValue="id"
                                        id={"location"}
                                        emptyMessage={t('noLocationYet')}
                                        className={classNames({'p-error': isFormFieldValid(meta)})}
                              />
                            </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/> */}
              <Field name="project" render={({ meta }) => (
                <div className="p-field p-fluid">
                  <label htmlFor="project" className={classNames({ 'p-error': isFormFieldValid(meta) })}>{props.t('project')}</label>
                  <span className="p-inputgroup">
                    <Button
                      type="button"
                      className="p-button"
                      onClick={() => {
                        let paramsObj = { ...window.App.urlVars() };
                        paramsObj.search = 'project';
                        let _params = "?";
                        Object.entries(paramsObj).forEach(([key, value]) => {
                          _params += key + "=" + value + "&";
                        });
                        history.push(window.location.hash.replace("#", "") + _params);
                      }}
                    >
                      <i className="pi pi-search"></i>
                    </Button>
                    <AutoComplete
                      id="project"
                      value={projectDisplay}
                      suggestions={projectSuggestions}
                      completeMethod={searchProject}
                      field="name"
                      delay={800}
                      forceSelection
                      placeholder={t('projectTypeToSearchPlaceholder')}
                      className={classNames({ "p-invalid": isFormFieldValid(meta) })}
                      onSelect={(e) => {
                        const picked = e.value;
                        setProjectSelected(true);
                        setProjectDisplay(picked.name || "");
                        const pid = picked.id || null;
                        setFormData(prev => ({ ...prev, project: pid,
                          //  warehouse: null
                           }));
                        setNewFormData(prev => ({ ...prev, project: pid,
                          //  warehouse: null
                           }));
                        // loadWarehouses(picked);
                      }}
                      onChange={(e) => {
                        if (projectSelected) {
                          setProjectSelected(false);
                          return;
                        }
                        setProjectDisplay(e.value);
                        setFormData(prev => ({ ...prev, project: null }));
                        setNewFormData(prev => ({ ...prev, project: null }));
                      }}
                      onClear={() => {
                        setProjectDisplay("");
                        setFormData(prev => ({ ...prev, project: null }));
                        setNewFormData(prev => ({ ...prev, project: null }));
                      }}
                    />
                  </span>

                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            {/* <div className={"p-col-12 p-lg-6"}>
                <Field name="warehouse" render={({ meta }) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="warehouse" className={classNames({ 'p-error': isFormFieldValid(meta) })}>{props.t('fieldWarehouse')}</label>
                    <span className={"p-d-block"}>
                      <Dropdown
                        id="warehouse"
                        value={formData?.warehouse?.id || formData.warehouse || null}
                        options={warehouses}
                        optionLabel="name"
                        optionValue="id"
                        disabled={!formData.project}
                        filter
                        emptyMessage={t('noWarehouseYet')}
                        onChange={(e) => {
                          setFormData(prev => ({ ...prev, warehouse: e.value }));
                          setNewFormData(prev => ({ ...prev, warehouse: e.value }));
                        }}
                      />
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div> */}
            {/*<div className={"p-col-12 p-lg-3"}>*/}
            {/*  <Field name="project" render={({input, meta}) => (*/}
            {/*    <div className="p-field p-fluid">*/}
            {/*      <label htmlFor="project"*/}
            {/*             className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('project')}</label>*/}
            {/*      <span className={"p-d-block"}>*/}
            {/*                  <Dropdown {...input}*/}
            {/*                            onChange={(e) => {*/}
            {/*                              setFormData({*/}
            {/*                                ...formData,*/}
            {/*                                project: e.target.value*/}
            {/*                              })*/}
            {/*                              setNewFormData({*/}
            {/*                                ...newFormData,*/}
            {/*                                project: e.target.value*/}
            {/*                              })*/}
            {/*                            }}*/}
            {/*                            value={formData?.project?.id || formData.project}*/}
            {/*                            options={projects}*/}
            {/*                            optionLabel="name"*/}
            {/*                            optionValue="id"*/}
            {/*                            id={"project"}*/}
            {/*                            emptyMessage={t('noProjectYet')}*/}
            {/*                            className={classNames({'p-error': isFormFieldValid(meta)})}*/}
            {/*                  />*/}
            {/*                </span>*/}
            {/*      {getFormErrorMessage(meta)}*/}
            {/*    </div>*/}
            {/*  )}/>*/}
            {/*</div>*/}
            {/*<div className={"p-col-12 p-lg-3"}>*/}
            {/*  <Field name="deadline" render={({input, meta}) => (*/}
            {/*    <span className="p-field p-fluid">*/}
            {/*        <label htmlFor="deadline"*/}
            {/*               className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('deadline')}</label>*/}
            {/*        <div className="p-inputgroup calendar-icon-only">*/}
            {/*                <InputMask id={"deadline"}*/}
            {/*                           mask={"9999-99-99"}*/}
            {/*                           placeholder={t('datePlaceholder')}*/}
            {/*                           value={moment.utc(formData.deadline).local().format('YYYY-MM-DD')}*/}
            {/*                           onChange={(e) => {*/}
            {/*                             if (e.value.indexOf("_") === -1) {*/}
            {/*                               if (e.value === '') {*/}
            {/*                                 e.value = null*/}
            {/*                               }*/}
            {/*                               setFormData({*/}
            {/*                                 ...formData,*/}
            {/*                                 deadline: new Date(e.value)*/}
            {/*                               })*/}
            {/*                               setNewFormData({*/}
            {/*                                 ...newFormData,*/}
            {/*                                 deadline: new Date(e.value)*/}
            {/*                               })*/}
            {/*                             }*/}
            {/*                           }}*/}
            {/*                />*/}
            {/*                <Calendar value={formData.deadline}*/}
            {/*                          locale="hu"*/}
            {/*                          dateFormat={'yy-mm-dd'}*/}
            {/*                          showIcon*/}
            {/*                          onChange={(e) => {*/}
            {/*                            setFormData({*/}
            {/*                              ...formData,*/}
            {/*                              deadline: e.value*/}
            {/*                            })*/}
            {/*                            setNewFormData({*/}
            {/*                              ...newFormData,*/}
            {/*                              deadline: e.value*/}
            {/*                            })*/}
            {/*                          }}/>*/}
            {/*        </div>*/}
            {/*      {getFormErrorMessage(meta)}*/}
            {/*      </span>*/}
            {/*  )}/>*/}
            {/*</div>*/}
            <div className={"p-col-12 p-lg-6"}>
              <Field name="contact" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="contact"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldContact')}</label>
                  {/*
                  <span className={"p-d-block"}>
                      <Dropdown {...input}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    contact: e.target.value
                                  })
                                  setNewFormData({
                                    ...newFormData,
                                    contact: e.target.value
                                  })
                                }}
                                value={formData?.contact?.id || formData.contact}
                                options={users}
                                optionLabel="name"
                                optionValue="id"
                                id={"contact"}
                                emptyMessage={t('noRequesterYet')}
                                className={classNames({'p-error': isFormFieldValid(meta)})}
                      />
                  </span>
                  */}
                  <span className="p-inputgroup">
                    <Button
                      type="button"
                      className="p-button"
                      onClick={() => {
                        let paramsObj = {...window.App.urlVars()};
                        paramsObj.search = 'employee';
                        let _params = "?";
                        Object.entries(paramsObj).forEach(([key, value]) => {
                          _params += key + "=" + value + "&";
                        });
                        history.push(window.location.hash.replace("#", "") + _params);
                      }}
                    >
                      <i className="pi pi-search"></i>
                    </Button>
                    <AutoComplete
                      id="contact"
                      value={contactDisplay}
                      suggestions={contactSuggestions}
                      completeMethod={searchContact}
                      field={"name"}
                      delay={800}
                      forceSelection
                      placeholder={t('typeToSearchPlaceholder')}
                      className={classNames({'p-invalid': isFormFieldValid(meta)})}
                      onSelect={(e) => {
                        const picked = e.value;
                        setContactDisplay(picked.name || "");
                        setFormData({
                          ...formData,
                          contact: picked.id
                        });
                        setNewFormData({
                          ...newFormData,
                          contact: picked.id
                        });
                      }}
                      onChange={(e) => {
                        setContactDisplay(e.value);
                        setFormData({
                          ...formData,
                          contact: null
                        });
                        setNewFormData({
                          ...newFormData,
                          contact: null
                        });
                      }}
                      onClear={() => {
                        setContactDisplay("");
                        setFormData({
                          ...formData,
                          contact: null
                        });
                        setNewFormData({
                          ...newFormData,
                          contact: null
                        });
                      }}
                    />
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>
              {/* {id && id !== 'undefined' &&
                <SplitButton
                // label={t(formData?.status?.toLowerCase())}
                label={labelForStatus(formData?.status)}
                             id="buttonStatus"
                             type="button"
                             loading={loading}
                             disabled={!id}
                             onClick={() => {
                               document.getElementById('buttonStatus').getElementsByClassName('p-splitbutton-menubutton')[0].click()
                             }}
                             icon="pi pi-info-circle"
                             className={"p-button-warning"}
                             model={statuses.map(status => {
                               const dictItem = statusDictionary.find(s => String(s.key).toUpperCase() === String(status.key).toUpperCase());
                               return (
                                 {
                                   label: dictItem?.value || status.value,
                                   command: () => {
                                     setLoading(true);
                                     apiCall('patch', '/api/v2/purchase-order/' + id, {
                                       status: status.value
                                     })
                                       .then(response => {
                                         window.App.toastShow('success', 'Sikeres módosítás', response.data.message);
                                         setFormData(response.data.data)
                                         setLoading(false);
                                       })
                                       .catch(error => {
                                         window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                         setLoading(false);
                                       })
                                   }
                                 }
                               )
                             })}/>
              } */}
            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {/*{entity === 'purchase-order' &&*/}
              {/*  <Button type="submit" label={t('save')}*/}
              {/*          loading={loading}*/}
              {/*          icon={"pi pi-save"}*/}
              {/*          className="p-button-success p-ml-2"/>*/}
              {/*}*/}
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(PurchaseorderFormComponent);
